import React, { useEffect, useState } from 'react';
import client from '../api/client';

export default function AppAdminUsers() {
  const [users, setUsers]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');

  useEffect(() => {
    setLoading(true);
    client.get('/orgs/all-users')
      .then(r => setUsers(r.data.users || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = search
    ? users.filter(u =>
        u.email.toLowerCase().includes(search.toLowerCase()) ||
        (u.display_name || '').toLowerCase().includes(search.toLowerCase()) ||
        (u.org_name || '').toLowerCase().includes(search.toLowerCase())
      )
    : users;

  const byOrg = filtered.reduce((acc, u) => {
    const key = u.org_name || 'No Organization';
    if (!acc[key]) acc[key] = [];
    acc[key].push(u);
    return acc;
  }, {});

  const statusBadge = (u) => {
    if (!u.active)
      return <span className="badge badge-secondary" style={{ fontSize: '10px' }}>Inactive</span>;
    if (!u.last_seen_at)
      return <span className="badge badge-warning" style={{ fontSize: '10px' }}>Never logged in</span>;
    return <span className="badge badge-success" style={{ fontSize: '10px' }}>Active</span>;
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 style={{ margin: 0, fontWeight: 600, fontSize: '16px' }}>
          All Users
          <span className="badge badge-secondary ml-2" style={{ fontSize: '12px', fontWeight: 400 }}>
            {users.length}
          </span>
        </h5>
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ width: '260px' }}
          placeholder="Search by email, name or org…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border text-danger" /></div>
      ) : (
        Object.entries(byOrg).map(([orgName, orgUsers]) => (
          <div className="card mb-3" key={orgName}>
            <div
              className="card-header py-2 d-flex align-items-center justify-content-between"
              style={{ backgroundColor: '#f8f9fa', fontSize: '13px' }}
            >
              <span style={{ fontWeight: 600 }}>{orgName}</span>
              <span className="badge badge-secondary" style={{ fontWeight: 400 }}>
                {orgUsers.length} user{orgUsers.length !== 1 ? 's' : ''}
              </span>
            </div>
            <div className="card-body p-0">
              <table className="table table-sm table-hover mb-0" style={{ fontSize: '12px' }}>
                <thead className="table-light">
                  <tr>
                    <th>Email</th>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th>Last Login</th>
                    <th>Joined</th>
                  </tr>
                </thead>
                <tbody>
                  {orgUsers.map(u => (
                    <tr key={u.id}>
                      <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {u.email}
                      </td>
                      <td>{u.display_name || '–'}</td>
                      <td>
                        <span className="badge badge-secondary" style={{ fontSize: '10px', textTransform: 'capitalize' }}>
                          {u.role}
                        </span>
                      </td>
                      <td>{statusBadge(u)}</td>
                      <td style={{ fontSize: '11px', color: '#6c757d' }}>
                        {u.last_seen_at
                          ? new Date(u.last_seen_at).toLocaleString('en-GB', {
                              day: '2-digit', month: 'short', year: 'numeric',
                              hour: '2-digit', minute: '2-digit',
                              timeZone: 'Europe/London',
                            })
                          : '–'}
                      </td>
                      <td style={{ fontSize: '11px', color: '#6c757d' }}>
                        {u.created_at ? new Date(u.created_at).toLocaleDateString('en-GB') : '–'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))
      )}

      {!loading && filtered.length === 0 && (
        <div className="text-center text-muted py-5" style={{ fontSize: '14px' }}>
          No users found
        </div>
      )}
    </div>
  );
}
